import { useState, useEffect, ChangeEvent } from 'react'

import {
  Grid,
  RadioGroup,
  Row,
  Button,
  Input,
  Select,
  Span,
  Picker,
  SelectForm,
  Form
} from 'components'
import { MagnifyingGlassIcon } from 'components/Icons'
import { useModal } from 'hooks'
import moment from 'moment'
import { notificationService } from 'services/NGT/Parameterization'
import { ISearchFilter } from 'services/NGT/PendingAnalysis'
import { SPACING } from 'utils'
import { SearchFilterProps } from '../../CheckListPending'
import { Control } from 'react-hook-form'

interface IFilterChecklistPendingProps {
  setChangeEffect: React.Dispatch<React.SetStateAction<boolean>>
  handleSubmit: any
  handleOnClear: () => void
  handleOnSearch: (_props: SearchFilterProps) => void
  areDatesValid: boolean
  errors?: any
  value: number
  control: Control<SearchFilterProps>
}
export const FilterChecklistPending = ({
  handleSubmit,
  handleOnClear,
  handleOnSearch,
  control,
  errors,
  areDatesValid,
  value
}: IFilterChecklistPendingProps) => {
  const [tipoDocumento, setTipoDocumento] = useState([])
  const [blockButton, setBlockButton] = useState<boolean>(false)
  const { showModal } = useModal()

  const searchTipoPendencia = () => {
    notificationService()
      .getPendencias()
      .then((response) => {
        setTipoDocumento(response.data.entity)
      })
      .catch(() => {
        showModal({
          hideButtonCancel: true,
          message: 'Infelizmente não foi possível bloquear',
          type: 'error'
        })
      })
  }

  const BlockButton = () => {
    let hasBlock = false

    if (errors)
      for (const [, value] of Object.entries(errors)) {
        if (String(Object.values(value)[0]).trim().length > 0) hasBlock = true
      }

    if (hasBlock) setBlockButton(true)
    else setBlockButton(false)
  }

  useEffect(() => {
    BlockButton()
  }, [errors])

  useEffect(() => {
    searchTipoPendencia()
  }, [])


  return (
    <Form onSubmit={handleSubmit(handleOnSearch)}>
      <Row marginTop={SPACING.spacing10}>
        <RadioGroup
          formValue="comDocumento"
          control={control}
          row
          labelMenu="label"
          valueMenu="value"
          listOptions={[
            { label: 'Com Documento', value: 'true' },
            { label: 'Sem Documento', value: 'false' },
            { label: 'Total', value: 'T' }
          ]}
        />
      </Row>
      <Grid
        gridCols="1fr 2.5fr 1.5fr 3fr"
        gridGap={`0 ${SPACING.spacing15}`}
        margin={`${SPACING.spacing10} 0 ${SPACING.spacing10} 0`}
        alignItems="flex-end"
      >
        <Input
          label="Contrato"
          placeholder="Nº"
          control={control}
          formValue="CdContrato"
          maxLength={100}
        />
        <Input
          label="Fornecedor"
          placeholder="Nome do Fornecedor"
          formValue="NmFornecedor"
          control={control}
          maxLength={100}
        />
        <SelectForm
          control={control}
          formValue="IdTipoPendencia"
          defaultValue={value}
          listOptions={tipoDocumento?.map((tipo) => (
            { label: tipo?.value, value: tipo?.key }
          ))}
          labelMenu="label"
          valueMenu="value"
          label="Tipo Documento"
          placeholder="Selecione"
        />
      </Grid>
      <Grid
        gridCols="1fr 0.1fr 0.9fr 1.3fr 0.1fr 1fr 2.7fr"
        gridGap={`0 ${SPACING.spacing10}`}
        margin={`${SPACING.spacing15} 0 ${SPACING.spacing10} 0`}
      >
        <Picker
          label="Competência"
          type="monthAndYear"
          allowTyping
          formValue='DtCompetenciaIni'
          control={control}
          errors={errors}
        />
        <Span text="à" marginTop={SPACING.spacing30} />
        <Picker
          label=""
          marginLeft="-10px"
          allowTyping
          type="monthAndYear"
          formValue='DtCompetenciaFim'
          control={control}
          errors={errors}
        />

        <Picker
          label="Data Anexada"
          marginLeft={SPACING.spacing50}
          allowTyping
          errors={errors}
          formValue='DtAnexadoIni'
          control={control}
        />
        <Span text="à" marginTop={SPACING.spacing30} />
        <Picker
          label=""
          marginLeft="-10px"
          allowTyping
          errors={errors}
          formValue='DtAnexadoFim'
          control={control}
        />

        <Row justifyContent="flex-end" marginTop={SPACING.spacing20}>
          <Button text="Limpar" variantButton="text" onClick={handleOnClear} />
          <Button
            type="submit"
            text="Pesquisar"
            disabled={blockButton}
            endIcon={<MagnifyingGlassIcon />}
            marginLeft={SPACING.spacing15}
          />
        </Row>
      </Grid>
    </Form>
  )
}
